import React from 'react';
import Box from '@mui/material/Box';
import { gql } from '@yi/core';

import { graphql } from 'gatsby';

import { CardContent, StylesWrapper, TeacherName } from './elements';
import { CurrentUser } from '../../CurrentUser';
import { FollowButton } from '../../FollowButton';
import { BaseCard, BaseCardProps } from '../bases';

type Item = gql.typesClient.Fragment_TeacherCard;
interface Props extends Omit<Partial<BaseCardProps>, 'onClick'> {
  item: Item;
  noHover?: boolean;
  light?: boolean;
  isLoadingExternally?: boolean;
  onClick?(i: Item): void;
}

export class TeacherCard extends React.Component<Props, {}> {
  static dimension = {
    width: 200,
    height: 264,
  };
  static graphql = graphql`
    fragment Fragment_TeacherCard on YI_Teacher {
      id
      localized_path
      snippet
      full_name
      main_style {
        name
      }
      image(params: { width: 350, format: webp }) {
        processed_url
      }
    }
  `;

  render() {
    const {
      item,
      noHover = true,
      onClick = () => undefined,
      light = false,
      isLoadingExternally,
      ...props
    } = this.props;
    const { id, image, full_name, localized_path } = item;
    const thumb = image ? image.processed_url : '';
    const imageHeight = 200;
    const { dimension } = TeacherCard;

    return (
      <CurrentUser>
        {({ isLoggedIn }) => (
          <StylesWrapper>
            <BaseCard
              onClick={() => onClick(item)}
              dimension={dimension}
              hoverable={!noHover}
              url={localized_path}
              thumb={thumb}
              imageHeight={imageHeight}
              bgImageFull={false}
              renderContent={() => (
                <CardContent light={light}>
                  <TeacherName>{full_name}</TeacherName>
                </CardContent>
              )}
              renderUpperRight={() =>
                isLoggedIn && (
                  <Box mt="-8px" mr="-10px">
                    <FollowButton
                      data-testid="article-teacher-follow-button"
                      contentId={id}
                      isLoadingExternally={isLoadingExternally}
                    />
                  </Box>
                )
              }
              {...props}
            />
          </StylesWrapper>
        )}
      </CurrentUser>
    );
  }
}
